/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HorseRegister,
  HorseRegisterDto,
} from '../models/index';
import {
    HorseRegisterFromJSON,
    HorseRegisterToJSON,
    HorseRegisterDtoFromJSON,
    HorseRegisterDtoToJSON,
} from '../models/index';

export interface ApiHorseRegisterPostRequest {
    horseRegisterDto?: HorseRegisterDto;
}

/**
 * 
 */
export class HorseRegisterApi extends runtime.BaseAPI {

    /**
     */
    async apiHorseRegisterPostRaw(requestParameters: ApiHorseRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HorseRegister>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/HorseRegister`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HorseRegisterDtoToJSON(requestParameters['horseRegisterDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HorseRegisterFromJSON(jsonValue));
    }

    /**
     */
    async apiHorseRegisterPost(requestParameters: ApiHorseRegisterPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HorseRegister> {
        const response = await this.apiHorseRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
